export const footerNav = [
  {
    id: 0,
    label: "About",
    url: "about",
  },
  {
    id: 1,
    label: "Terms & Conditions",
    url: "terms-and-conditions",
  },
  {
    id: 2,
    label: "Join Us",
    url: "join-us",
  },
] 